import { render, staticRenderFns } from "./AbaSocietario.vue?vue&type=template&id=05060ef4&"
import script from "./AbaSocietario.vue?vue&type=script&lang=js&"
export * from "./AbaSocietario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports